export const EMPLOYEE_URL = 'employee/profile';
